import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/snooker_bg.png'
import _imports_1 from '@/assets/img/DDBU-TV-LOGO.png'
import _imports_2 from '@/assets/img/Frame.png'


const _withScopeId = n => (_pushScopeId("data-v-78378d04"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"image-container\" data-v-78378d04><a href=\"http://www.spildart.nu/\" target=\"_blank\" rel=\"noopener\" class=\"image-link\" data-v-78378d04><img src=\"" + _imports_0 + "\" alt=\"Background Image\" class=\"background-image\" data-v-78378d04><div class=\"overlay\" data-v-78378d04><img src=\"" + _imports_1 + "\" alt=\"Logo\" class=\"logo\" data-v-78378d04><h2 class=\"title\" data-v-78378d04>Billard also have</h2><button class=\"cta-button\" data-v-78378d04>Click Here</button></div></a></div>", 1)
const _hoisted_2 = { class: "shortcuts-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "shortcut-title" }, "Genveje", -1))
const _hoisted_4 = { class: "shortcut-list" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"newsletter-container\" data-v-78378d04><div class=\"overlay\" data-v-78378d04><img src=\"" + _imports_2 + "\" alt=\"Logo\" class=\"logo\" data-v-78378d04><h2 class=\"news-title\" data-v-78378d04>Subscribe to newsletter</h2><input class=\"emailInput\" type=\"email\" placeholder=\"Email Address\" data-v-78378d04><button class=\"cta-button\" data-v-78378d04>Submit</button></div></div>", 1)
const _hoisted_7 = { class: "shortcuts-container" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "shortcut-title" }, "Follow Us", -1))
const _hoisted_9 = { class: "shortcut-list" }
const _hoisted_10 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_va_icon = _resolveComponent("va-icon")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("ul", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shortcuts, (menu, index) => {
          return (_openBlock(), _createElementBlock("li", {
            key: index,
            class: "shortcut-item",
            onClick: ($event: any) => (_ctx.navigationRouter(menu.link))
          }, [
            _createVNode(_component_va_icon, {
              name: "arrow_forward",
              class: "ml-2",
              color: "#b4003a"
            }),
            _createTextVNode(" " + _toDisplayString(menu.name), 1)
          ], 8, _hoisted_5))
        }), 128))
      ])
    ]),
    _hoisted_6,
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _createElementVNode("ul", _hoisted_9, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.followUs, (shortcut, index) => {
          return (_openBlock(), _createElementBlock("li", {
            key: index,
            class: "shortcut-item"
          }, [
            _createElementVNode("a", {
              href: shortcut.link
            }, [
              _createVNode(_component_font_awesome_icon, {
                icon: ['fab', shortcut.icon],
                alt: shortcut.alt,
                style: {"width":"20px","height":"20px","color":"#b4003a"},
                class: "pr-2"
              }, null, 8, ["icon", "alt"]),
              _createTextVNode(_toDisplayString(shortcut.name), 1)
            ], 8, _hoisted_10)
          ]))
        }), 128))
      ])
    ])
  ], 64))
}